module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /home/mudassir/.nvm/v8.7.0/lib/node_modules/react-scripts/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 1006
// module chunks = 0